import PropTypes from 'prop-types'
import { Sort } from '@mui/icons-material'
import { MenuItem, Select } from '@mui/material'

import { SORT_BY_OPTIONS } from './helpers'
import { useTranslation } from 'react-i18next'

const SortBySelect = ({ value, onChange }) => {
  const { i18n } = useTranslation()
  const t = i18n.getResourceBundle(i18n.language)
  const items = SORT_BY_OPTIONS({ t })

  return (
    <div className="Search-page__filters-sorting-wrapper">
      <span>{t.search.filter.sortBy}</span>
      <Select
        className="Search-page__filters-sorting"
        value={value}
        IconComponent={Sort}
        onChange={onChange}
      >
        {items.map(({ value, label }, index) => {
          const lastClass = index + 1 === items.length ? 'last' : ''

          return (
            <MenuItem
              key={index}
              className={`Search-page__filters-menu-item ${lastClass}`}
              value={value}
            >
              {label}
            </MenuItem>
          )
        })}
      </Select>
    </div>
  )
}

SortBySelect.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
}

export default SortBySelect
